import * as is from './is';
import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';
import Url, { newUrl } from './Url';
import Parenthesis from './Parenthesis';

export default class ImportRule extends Layer                             {
	
	get [Symbol.toStringTag] () { return 'ImportRule'; }
	
	                 keywordLiteral        ;
	urlLayer      ;
	get block () { return !this.urlLayer; }
	
	constructor (keywordLiteral         ) {
		super();
		this.keywordLiteral = keywordLiteral || 'import';
		return this;
	}
	
	[TOKEN.consume] (                ) {
		switch ( TOKEN.type ) {
			case TOKEN.whitespace:
				this.length && ( this.newItem = ' ' );
				return this;
			case TOKEN.string:
				if ( this.urlLayer ) { break; }
				( this.urlLayer = new Url(null) ).valueLiteral = TOKEN.literal;
				return this;
			case TOKEN.url:
				if ( this.urlLayer ) { break; }
				if ( TOKEN.literal[3]==='(' ) { return newUrl(this, 'urlLayer'); }
				break;
			case TOKEN.function_:
				if ( is.url_ (TOKEN.literal) ) {
					if ( this.urlLayer ) { break; }
					return this.urlLayer = new Url(TOKEN.literal.slice(0, 3));
				}
			case '(':
				if ( !this.urlLayer ) { break; }
				return this.newItem = new Url(TOKEN.literal.slice(0, -1));
			case TOKEN.ident:
			case ':':
			case ',':
				if ( !this.urlLayer ) { break; }
				this.newItem = TOKEN.literal;
				return this;
			case ';':
				if ( !this.urlLayer ) { break; }
				return this[TOKEN.parent];
			case TOKEN.comment:
				this.length && ( this.newItem = '/**/' );
				return this;
		}
		return null;
	}
	
	[Symbol.toPrimitive] (                ) {
		const urlLiteral = '' + this.urlLayer;
		return `@${this.keywordLiteral}${urlLiteral && ( urlLiteral[0]==='"' || urlLiteral==='\'' ) ? '' : ' '}${urlLiteral}${this.join('')};`;
	}
	
	* [Symbol.iterator] (                )                                {
		yield `@${this.keywordLiteral} ${this.urlLayer}${this.length ? ' ' + this.join('') : ''};`;
	}
	
	static default = protect(this);
	
};
